// module for fetching data from the backend API
// TODO: change functions to be async and use await instead of .then
// Copy right - © 2024 tecera gmbh


import { all_hymos,customer_list, alarm_recipient_list, all_compound_water_meters, current_sample_time, current_device_data_additional_values, free_hymos, water_meter_alarms_triggered_old, water_meter_alarms_triggered_new, free_water_meters, hymo_alarms_triggered_new, hymo_alarms_triggered_old, all_water_meters, last_meta_data, current_device_data, is_loading_current_device_data, user_list, all_water_meter_boxes, extended_device_channel_list, selected_device } from "../stores.js";
import { get } from 'svelte/store';
import { BASE_API_URL } from '../config.js';
import { logout } from "./auth.js";
import { find_main_meter } from "./utils.js";



export function handle_bad_response(response) {
    if (response.status === 401) {
        let message = "Ihre Session ist abgelaufen. Bitte loggen sie sich erneut ein.";
        logout({ error_message: message });
    }
    throw new Error(`HTTP error! status: ${response.status}`);
}

// ------------ Hymo data ----------------

// fetching all free hymos that dont have a hymo_config
export async function get_free_hymos(group = null, sub_group = null) {
    let url_extension = "/free_hymos/";
    let request_url = BASE_API_URL + url_extension;
    try {
        if (group !== null) {
            const response = await fetch(
                request_url + "group/",
                {
                    method: "POST",
                    headers: {
                        Authorization: `Token ${sessionStorage.getItem(
                            "2kai_access_token",
                        )}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ group: group, sub_group: sub_group }),
                },
            );

            if (!response.ok) {
                handle_bad_response(response);
                return false;
            }
            let api_result = await response.json();
            free_hymos.set(api_result.data);
            return true;
        }
        else {
            const response = await fetch(
                request_url,
                {
                    // lookin for dry-contact devices
                    method: "GET",
                    headers: {
                        Authorization: `Token ${sessionStorage.getItem(
                            "2kai_access_token",
                        )}`,
                        "Content-Type": "application/json",
                    },
                },
            );

            if (!response.ok) {
                handle_bad_response(response);
                return false;
            }
            let api_result = await response.json();
            free_hymos.set(api_result);
            return true;
        }
    } catch (error) {
        return false;
    }
}

// fetching all hymo configs
export async function get_hymo_configs(group = null, sub_group = null) {
    let url_extension = "/hymo_configs/";
    let request_url = BASE_API_URL + url_extension;
    try {
        if (group !== null) {
            const response = await fetch(
                request_url + "group/",
                {
                    method: "POST",
                    headers: {
                        Authorization: `Token ${sessionStorage.getItem(
                            "2kai_access_token",
                        )}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ group: group, sub_group: sub_group }),
                },
            );
            if (!response.ok) {
                handle_bad_response(response);
                return false;
            }

            let api_result = await response.json();
            api_result.data.sort((a, b) => {
                if (a.sub_group && b.sub_group) {
                    return a.sub_group.localeCompare(b.sub_group);
                }
                return 0;
            });
            all_hymos.set(api_result.data);
            return true;
        }
        else {
            const response = await fetch(
                request_url,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Token ${sessionStorage.getItem(
                            "2kai_access_token",
                        )}`,
                        "Content-Type": "application/json",
                    },
                },
            );
            if (!response.ok) {
                handle_bad_response(response);
                return false;
            }
            let api_result = await response.json();
            all_hymos.set(api_result.data);
            return true;
        }
    } catch (error) {
        return false;
    }

}

// ------------ water meter data----------------

// fetching all free water meters that dont have a water_meter_config
// experimental with await block
export async function get_free_water_meters() {
    let url_extension = "/free_water_meters/";
    let request_url = BASE_API_URL + url_extension;
    try {
        const response = await fetch(
            request_url,
            {
                method: "GET",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            },
        );

        if (!response.ok) {
            handle_bad_response(response);
            return false;
        }

        let api_result = await response.json();
        free_water_meters.set(api_result);
        return true;
    } catch (error) {
        return false;
    }
}

// fetching all hymo configs
export async function get_water_meter_configs() {
    let url_extension = "/water_meter_configs/";
    let request_url = BASE_API_URL + url_extension;
    try {
        const response = await fetch(
            request_url,
            {
                method: "GET",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            },
        );

        if (!response.ok) {
            handle_bad_response(response);
            return false;
        }

        let api_result = await response.json();
        all_water_meters.set(api_result);
        return true;

    } catch (error) {
        return false;
    }

}

// fetching all current_alarms
export async function get_alarms_current_hymo(hymo_group="hymo") {
    let url_extension = "/alarms_current_" + hymo_group + "/";
    let request_url = BASE_API_URL + url_extension;
    try {
        const response = await fetch(
            request_url,
            {
                method: "GET",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            },
        );

        if (!response.ok) {
            handle_bad_response(response);
            return false;
        }

        let data = await response.json();
        hymo_alarms_triggered_new.set(data);
        return true;

    } catch (error) {
        return false;
    }

}

// fetching all old alarms
export async function get_alarms_old_hymo(hymo_group="hymo") {
    let url_extension = "/alarms_old_" + hymo_group + "/";
    let request_url = BASE_API_URL + url_extension;
    try {
        const response = await fetch(
            request_url,
            {
                method: "GET",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            },
        );

        if (!response.ok) {
            handle_bad_response(response);
            return false;
        }

        let data = await response.json();
        hymo_alarms_triggered_old.set(data);
        return true;

    } catch (error) {
        return false;
    }


}

// fetching all current_alarms
export async function get_alarms_current_water_meter() {
    let url_extension = "/alarms_current_water_meter/";
    let request_url = BASE_API_URL + url_extension;
    try {
        const response = await fetch(
            request_url,
            {
                method: "GET",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            },
        );

        if (!response.ok) {
            handle_bad_response(response);
            return false;
        }

        let data = await response.json();
        water_meter_alarms_triggered_new.set(data);
        return true;

    } catch (error) {
        return false;
    }
}

// fetching all old alarms
export async function get_alarms_old_water_meter() {
    let url_extension = "/alarms_old_water_meter/";
    let request_url = BASE_API_URL + url_extension;
    try {
        const response = await fetch(
            request_url,
            {
                method: "GET",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            },
        );

        if (!response.ok) {
            handle_bad_response(response);
            return false;
        }

        let data = await response.json();
        water_meter_alarms_triggered_old.set(data);
        return true;

    } catch (error) {
        return false;
    }

}


// TODO: Functions for fetching water meter alarms, Promise implementation


export async function get_hymo_data(device_config_id, start_date, end_date) {
    let start_date_unix = Date.parse(start_date) / 1000;
    let end_date_unix = Date.parse(end_date) / 1000;
    let url_extension = `/hymo_data/${device_config_id}/?start_date=${start_date_unix}&end_date=${end_date_unix}`;
    let request_url = BASE_API_URL + url_extension;
    is_loading_current_device_data.set(true);
    try {
        const response = await fetch(
            request_url,
            {
                method: "GET",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            },
        );

        let data = await response.json();

        if (!response.ok) {
            last_meta_data.set(null);
            current_device_data.set(null);
            is_loading_current_device_data.set(false);
            handle_bad_response(response);
            return false;
        }

        if (data["last_meta_data"] == null) {
            last_meta_data.set(null);

        } else {
            last_meta_data.set(data["last_meta_data"]);
        }
        if (data["data"] == null) {
            current_device_data.set(null);


        } else {
            current_device_data.set(data["data"]);
        }
        let time_text = "Echtzeitwerte";

        current_sample_time.set(time_text);
        is_loading_current_device_data.set(false);
        return true;

    } catch (error) {
        return false;
    }
}

// fetches compound water meters
export async function get_compound_water_meters() {
    let url_extension = "/compound_water_meters/";
    let request_url = BASE_API_URL + url_extension;
    try {
        const response = await fetch(
            request_url,
            {
                method: "GET",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            },
        );

        if (!response.ok) {
            handle_bad_response(response);
            return false;
        }


        let data = await response.json();
        all_compound_water_meters.set(data);
        return true;

    } catch (error) {
        return false;
    }

}


// fetches water meter boxes
export async function get_water_meter_boxes() {
    let url_extension = "/water_meter_boxes/";
    let request_url = BASE_API_URL + url_extension;
    try {
        const response = await fetch(
            request_url,
            {
                method: "GET",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            },
        );

        if (!response.ok) {
            handle_bad_response(response);
            return false;
        }


        let data = await response.json();
        all_water_meter_boxes.set(data);

        return true;

    } catch (error) {
        return false;
    }

}


// unfinished

// fetching all devices of type hymo with channels and alarms - not used
// update for different device types on implementation
export async function get_alarm_defaults() {
    let url_extension = "/alarm_defaults/";
    let request_url = BASE_API_URL + url_extension;
    try {
        const response = await fetch(
            request_url,
            {
                method: "GET",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            },
        );

        if (!response.ok) {
            handle_bad_response(response);
            return false;
        }

        let data = await response.json();
        return true;

    } catch (error) {
        return false;
    }
}


export async function get_compound_water_meter_data(compound_id, start_date, end_date) {
    let start_date_unix = Date.parse(start_date) / 1000;
    let end_date_unix = Date.parse(end_date) / 1000;
    let url_extension = `/compound_water_meter_data/${compound_id}/?start_date=${start_date_unix}&end_date=${end_date_unix}`;
    let request_url = BASE_API_URL + url_extension;
    is_loading_current_device_data.set(true);
    try {
        const response = await fetch(request_url,
            {
                method: "GET",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            },
        );

        let data = await response.json();
        if (!response.ok) {
            last_meta_data.set(null);
            current_device_data.set(null);
            current_device_data_additional_values.set(null);
            is_loading_current_device_data.set(false);
            handle_bad_response(response);
            return false;
        }



        if (data["last_meta_data"] == null) {
            last_meta_data.set(null);

        } else {
            last_meta_data.set(data["last_meta_data"]);
        }
        if (data["data"] == null) {
            current_device_data.set(null);
        } else {
            current_device_data.set(data["data"]);
            let raw_data = get(current_device_data);

            let time_text = data["sample_time"] == null ? "Echtzeitwerte" : (data["sample_time"] == "1d" ? "Tageswerte" : "Stundenwerte");

            current_sample_time.set(time_text);

            // Step 1 & 2: Create a Set of unique timestamps
            let timestamps = new Set();
            raw_data.forEach(config => {
                config.data.forEach(point => {
                    timestamps.add(point.received_at);
                });
            });

            // Step 3: Convert the Set back to an array and sort it
            timestamps = Array.from(timestamps);
            timestamps.sort();


            // Step 4: Fill in the timestamps
            let filledData = raw_data.map(config => {
                let last_meter_reading = null;
                let filledDataPoints = timestamps.map(timestamp => {
                    let point = config.data.find(point => point.received_at === timestamp);
                    if (point) {
                        last_meter_reading = point.meter_reading;
                        return point;
                    } else if (last_meter_reading !== null) {
                        return {
                            received_at: timestamp,
                            volume_flow: null,
                            meter_reading: last_meter_reading,
                        };
                    }
                    return {
                        received_at: timestamp,
                        volume_flow: null,
                        meter_reading: null,
                    };
                })
                // .filter(point => point !== null);
                return {
                    ...config,
                    data: filledDataPoints
                };
            });

            let summed_data = timestamps.map(timestamp => {
                let pointsAtTimestamp = filledData.flatMap(config => config.data.filter(point => point.received_at === timestamp));
                let sum = pointsAtTimestamp.reduce((total, point) => {
                    return {
                        meter_reading: total.meter_reading + point.meter_reading,
                        volume_flow: total.volume_flow + point.volume_flow
                    };
                }, { meter_reading: 0, volume_flow: 0 });
                return {
                    received_at: timestamp,
                    meter_reading_sum: sum.meter_reading,
                    volume_flow_sum: sum.volume_flow,
                };
            });

            current_device_data.set(filledData);
            current_device_data_additional_values.set(summed_data);
        }
        is_loading_current_device_data.set(false);
        return true;
    } catch (error) {
        return false;
    }

}

export async function get_compound_water_meter_csv_data(compound_id, start_date, end_date) {
    let start_date_unix = Date.parse(start_date) / 1000;
    let end_date_unix = Date.parse(end_date) / 1000;
    let url_extension = `/compound_water_meter_data/${compound_id}?start_date=${start_date_unix}&end_date=${end_date_unix}`;
    let request_url = BASE_API_URL + url_extension;
    try {
        const response = await fetch(request_url,
            {
                method: "GET",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            },
        );

        let data = await response.json();
        if (!response.ok) {
            handle_bad_response(response);
            return false;
        }
        let raw_data = data["data"];

        // Step 1 & 2: Create a Set of unique timestamps
        let timestamps = new Set();
        raw_data.forEach(config => {
            config.data.forEach(point => {
                timestamps.add(point.received_at);
            });
        });

        // Step 3: Convert the Set back to an array and sort it
        timestamps = Array.from(timestamps);
        timestamps.sort();

        let is_multi_compound = find_main_meter(get(selected_device)).compound_role === "main";
        // Step 4: Fill in the timestamps
        let filledData = raw_data.map(config => {
            config.device_config = get(selected_device).watermeterconfigs.find(wm_config => wm_config.id === config.config_id);
            let last_meter_reading = null;
            let filledDataPoints = timestamps.map(timestamp => {
                let point = config.data.find(point => point.received_at === timestamp);
                if (point) {
                    last_meter_reading = point.meter_reading;
                    return point;
                } else if (last_meter_reading !== null) {
                    return {
                        received_at: timestamp,
                        volume_flow: null,
                        meter_reading: last_meter_reading,
                    };
                }
                return {
                    received_at: timestamp,
                    volume_flow: null,
                    meter_reading: null,
                };
            })
            // .filter(point => point !== null);
            return {
                ...config,
                data: filledDataPoints
            };
        });
        let summed_data = [];
        if (is_multi_compound) {
            summed_data = timestamps.map(timestamp => {
                let pointsAtTimestamp = filledData.flatMap(config => config.data.filter(point => point.received_at === timestamp));
                let sum = pointsAtTimestamp.reduce((total, point) => {
                    return {
                        meter_reading: total.meter_reading + point.meter_reading,
                        volume_flow: total.volume_flow + point.volume_flow
                    };
                }, { meter_reading: 0, volume_flow: 0 });
                return {
                    received_at: timestamp,
                    meter_reading_sum: sum.meter_reading,
                    volume_flow_sum: sum.volume_flow,
                };
            });
        }
        return [filledData, summed_data];
    } catch (error) {
        return false;
    }

}

export async function get_device_list_csv_data(device_id_list, start_date, end_date, resample_time, signal,type="compound_water_meter") {
    let start_date_unix = Date.parse(start_date) / 1000;
    let end_date_unix = Date.parse(end_date) / 1000;
    let url_extension = `/${type}_data/batch_retrieve/`;
    let request_url = BASE_API_URL + url_extension;
    let post_data = {
        device_ids: device_id_list,
        start_date: start_date_unix,
        end_date: end_date_unix,
        resample_time: resample_time
    }
    try {
        const response = await fetch(request_url,
            {
                method: "POST",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(post_data),
                signal: signal,
            },
        );

        let data = await response.json();
        if (!response.ok) {
            handle_bad_response(response);
            return false;
        }
        if(type != "compound_water_meter"){
            return data.data;
        }
        let final_data = [];
        // loop through each compound
        data.data.forEach(compound_data => {
            let raw_data = compound_data;

            // Step 1 & 2: Create a Set of unique timestamps
            let timestamps = new Set();
            raw_data.forEach(config => {
                config.data.forEach(point => {
                    timestamps.add(point.received_at);
                });
            });

            // Step 3: Convert the Set back to an array and sort it
            timestamps = Array.from(timestamps);
            timestamps.sort();
            let is_multi_compound = !(compound_data[0].config.compound_role === "single");   // multi compound check to determine if summed data should be calculated
            // Step 4: Fill in the timestamps
            let filledData = raw_data.map(config => {
                let last_meter_reading = null;
                let filledDataPoints = timestamps.map(timestamp => {
                    let point = config.data.find(point => point.received_at === timestamp);
                    if (point) {
                        last_meter_reading = point.meter_reading;
                        return point;
                    } else if (last_meter_reading !== null) {
                        return {
                            received_at: timestamp,
                            volume_flow: null,
                            meter_reading: last_meter_reading,
                        };
                    }
                    return {
                        received_at: timestamp,
                        volume_flow: null,
                        meter_reading: null,
                    };
                })
                // .filter(point => point !== null);
                return {
                    ...config,
                    data: filledDataPoints
                };
            });
            let summed_data = [];
            if (is_multi_compound) {
                summed_data = timestamps.map(timestamp => {
                    let pointsAtTimestamp = filledData.flatMap(config => config.data.filter(point => point.received_at === timestamp));
                    let sum = pointsAtTimestamp.reduce((total, point) => {
                        return {
                            meter_reading: total.meter_reading + point.meter_reading,
                            volume_flow: total.volume_flow + point.volume_flow
                        };
                    }, { meter_reading: 0, volume_flow: 0 });
                    return {
                        received_at: timestamp,
                        meter_reading_sum: sum.meter_reading,
                        volume_flow_sum: sum.volume_flow,
                    };
                });
            }
            final_data.push([filledData, summed_data]);
        });
        return final_data;
    } catch (error) {
        return false;
    }
}

export function create_extended_channel_list(multiple_devices = false) {
    let channels = [];
    let old_channel_list = get(extended_device_channel_list);
    extended_device_channel_list.set([]);

    function check_old_visibility(channel) {
        let old_channel = old_channel_list.find(old_channel => old_channel.measurand === channel.measurand);
        if (old_channel) {
            return old_channel.visible;
        }

        return channel.measurand=="Pegelstand";
    }
    if (multiple_devices) {
        let is_compound = find_main_meter(get(selected_device)).compound_role === "main";
        let added_channels = [

            {
                name: "volume_flow_sum",
                display_name: "Volumenstrom (m³/h) - Gesamt",
                measurand: "Volumenstrom",
                config: null,
                channel_id: -1,
                visible: true,
                unit: "m³/h",
            }, {
                name: "meter_reading_sum",
                display_name: "Zählerstand (m³) - Gesamt",
                measurand: "Zählerstand",
                config: null,
                channel_id: -2,
                visible: true,
                unit: "m³",
            },
        ];
        if (is_compound) {
            channels = added_channels;
        }
        get(selected_device).watermeterconfigs.map((config) => {
            config.channels.map((channel) => {
                let display_name = `${channel.measurand} (${channel.unit}) - ${config.sub_id}`
                channels.push({
                    name: channel.name,
                    display_name: display_name,
                    measurand: channel.measurand,
                    config: config.id,
                    channel_id: channel.id,
                    sub_id: config.sub_id,
                    unit: channel.unit,
                    visible: true,
                });
            });
        });
    } else {
        get(selected_device).channels.map((channel) => {
            let display_name = `${channel.measurand}`
            channels.push({
                name: channel.name,
                display_name: display_name,
                measurand: channel.measurand,
                channel_id: channel.id,
                id: channel.id,
                visible: check_old_visibility(channel),
                unit: channel.unit,
                boolean_0: channel.boolean_0,
                boolean_1: channel.boolean_1,
            });
        });
    }
    extended_device_channel_list.set(channels.sort(
        (a, b) => a.measurand.localeCompare(b.measurand)
    ));
}

export async function get_user_list() {
    let url_extension = "/users/";
    let request_url = BASE_API_URL + url_extension;
    try {
        const response = await fetch(
            request_url,
            {
                method: "GET",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            },
        );

        if (!response.ok) {
            handle_bad_response(response);
            return false;
        }

        let api_result = await response.json();
        user_list.set(api_result.sort( (a, b) => a.email.localeCompare(b.email), ));
        return true;
    } catch (error) {
        return false;
    }
}

export async function get_customer_list() {
    let url_extension = `/customers/subcustomers/`;
    let request_url = BASE_API_URL + url_extension;
    try {
        const response = await fetch(
            request_url,
            {
                method: "GET",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            },
        );

        if (!response.ok) {
            handle_bad_response(response);
            return false;
        }

        let api_result = await response.json();
        customer_list.set(api_result);
        return true;
    } catch (error) {
        return false;
    }
}

export async function get_hymo_alarm_recipients(id) {
    let url_extension = `/hymo_alarm_recipients/${id}/`;
    let request_url = BASE_API_URL + url_extension;

    try {
        const response = await fetch(
            request_url,
            {
                method: "GET",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            },
        );
        if (!response.ok) {
            handle_bad_response(response);
            return false;
        }
        let api_result = await response.json();
        alarm_recipient_list.set(api_result.data);
        return true;
    } catch (error) {
        return false;
    }
}

export async function add_hymo_alarm_recipients(id, user_id) {
    let url_extension = `/hymo_alarm_recipients/${id}/`;
    let request_url = BASE_API_URL + url_extension;
    let put_data = {
        user_id: user_id,
    }
    try {
        const response = await fetch(
            request_url,
            {
                method: "PUT",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(put_data),
            },
        );
        if (!response.ok) {
            handle_bad_response(response);
            return false;
        }
        let api_result = await response.json();
        let data = api_result.data;
        current_device.channels.set(data);
        return true;
    } catch (error) {
        return false;
    }
}

export async function remove_hymo_alarm_recipients(id, user_id) {
    let url_extension = `/hymo_alarm_recipients/${id}/`;
    let request_url = BASE_API_URL + url_extension;
    let put_data = {
        user_id: user_id,
    }
    try {
        const response = await fetch(
            request_url,
            {
                method: "DELETE",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(put_data),
            },
        );
        if (!response.ok) {
            handle_bad_response(response);
            return false;
        }
        return true;
    } catch (error) {
        return false;
    }
}

export async function get_water_meter_alarm_recipients(id) {
    let url_extension = `/water_meter_alarm_recipients/${id}/`;
    let request_url = BASE_API_URL + url_extension;

    try {
        const response = await fetch(
            request_url,
            {
                method: "GET",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            },
        );
        if (!response.ok) {
            handle_bad_response(response);
            return false;
        }
        let api_result = await response.json();
        alarm_recipient_list.set(api_result.data);
        return true;
    } catch (error) {
        return false;
    }
}

export async function add_water_meter_alarm_recipients(id, user_id) {
    let url_extension = `/water_meter_alarm_recipients/${id}/`;
    let request_url = BASE_API_URL + url_extension;
    let put_data = {
        user_id: user_id,
    }
    try {
        const response = await fetch(
            request_url,
            {
                method: "PUT",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(put_data),
            },
        );
        if (!response.ok) {
            handle_bad_response(response);
            return false;
        }
        let api_result = await response.json();
        let data = api_result.data;
        current_device.alarms.set(data);
        return true;
    } catch (error) {
        return false;
    }
}

export async function remove_water_meter_alarm_recipients(id, user_id) {
    let url_extension = `/water_meter_alarm_recipients/${id}/`;
    let request_url = BASE_API_URL + url_extension;
    let put_data = {
        user_id: user_id,
    }
    try {
        const response = await fetch(
            request_url,
            {
                method: "DELETE",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(put_data),
            },
        );
        if (!response.ok) {
            handle_bad_response(response);
            return false;
        }
        return true;
    } catch (error) {
        return false;
    }
}

export async function remove_device_from_customer(device_id) {
    let url_extension = `/remove_device_from_customer/${device_id}/`;
    let request_url = BASE_API_URL + url_extension;
    try {
        const response = await fetch(
            request_url,
            {
                method: "PATCH",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            },
        );
        if (!response.ok) {
            handle_bad_response(response);
            return false;
        }
        let data = await response.json();
        return data.success;
    } catch (error) {
        return false;
    }
}